// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WomenRouteImport } from './routes/women'
import { Route as WishlistRouteImport } from './routes/wishlist'
import { Route as UnisexRouteImport } from './routes/unisex'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as RidersRouteImport } from './routes/riders'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OurStoryRouteImport } from './routes/our-story'
import { Route as NewArrivalsRouteImport } from './routes/new-arrivals'
import { Route as MenRouteImport } from './routes/men'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CartRouteImport } from './routes/cart'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AccessoriesRouteImport } from './routes/accessories'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JournalIndexRouteImport } from './routes/journal.index'
import { Route as ProductSlugRouteImport } from './routes/product.$slug'
import { Route as JournalSlugRouteImport } from './routes/journal.$slug'

const WomenRoute = WomenRouteImport.update({
            id: '/women',path: '/women',getParentRoute: () => rootRouteImport
          })
const WishlistRoute = WishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => rootRouteImport
          })
const UnisexRoute = UnisexRouteImport.update({
            id: '/unisex',path: '/unisex',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const ShippingRoute = ShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => rootRouteImport
          })
const RidersRoute = RidersRouteImport.update({
            id: '/riders',path: '/riders',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ReturnsRoute = ReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const OurStoryRoute = OurStoryRouteImport.update({
            id: '/our-story',path: '/our-story',getParentRoute: () => rootRouteImport
          })
const NewArrivalsRoute = NewArrivalsRouteImport.update({
            id: '/new-arrivals',path: '/new-arrivals',getParentRoute: () => rootRouteImport
          })
const MenRoute = MenRouteImport.update({
            id: '/men',path: '/men',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AccessoriesRoute = AccessoriesRouteImport.update({
            id: '/accessories',path: '/accessories',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const JournalIndexRoute = JournalIndexRouteImport.update({
            id: '/journal/',path: '/journal/',getParentRoute: () => rootRouteImport
          })
const ProductSlugRoute = ProductSlugRouteImport.update({
            id: '/product/$slug',path: '/product/$slug',getParentRoute: () => rootRouteImport
          })
const JournalSlugRoute = JournalSlugRouteImport.update({
            id: '/journal/$slug',path: '/journal/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccessoriesRoute: AccessoriesRoute,AuthRoute: AuthRoute,CartRoute: CartRoute,ContactRoute: ContactRoute,MenRoute: MenRoute,NewArrivalsRoute: NewArrivalsRoute,OurStoryRoute: OurStoryRoute,PrivacyRoute: PrivacyRoute,ReturnsRoute: ReturnsRoute,ReviewsRoute: ReviewsRoute,RidersRoute: RidersRoute,ShippingRoute: ShippingRoute,ShopRoute: ShopRoute,TermsRoute: TermsRoute,UnisexRoute: UnisexRoute,WishlistRoute: WishlistRoute,WomenRoute: WomenRoute,JournalSlugRoute: JournalSlugRoute,ProductSlugRoute: ProductSlugRoute,JournalIndexRoute: JournalIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)